import { Outlet } from 'react-router-dom';
import Container from './Container';
import Header from './Header';
import Footer from './Footer';

const Layout = () => {
  return (
    <>
      <Header />

      <Container>
        <Outlet />
      </Container>

      {/* <Footer/> */}
    </>
  );
};

export default Layout;
